package com.rosario.juridico.domain

import juridico5.composeapp.generated.resources.Res
import org.jetbrains.compose.resources.ExperimentalResourceApi

@OptIn(ExperimentalResourceApi::class)
object PlazosRepository {
    private var cachedPlazos: List<PlazoRecord>? = null

    suspend fun getPlazos(): List<PlazoRecord> {
        if (cachedPlazos != null) return cachedPlazos!!

        val plazos = mutableListOf<PlazoRecord>()
        try {
            val bytes = Res.readBytes("files/vencimientos_procesales.txt")
            val contenido = bytes.decodeToString()
            
            contenido.lines().forEachIndexed { index, linea ->
                // Omitir cabecera si existe
                if (index == 0 && linea.contains("CATEGORIA|DESCRIPCION")) return@forEachIndexed
                
                val l = linea.trim()
                if (l.isEmpty() || l.startsWith("#")) return@forEachIndexed

                val partes = l.split("|")
                if (partes.size >= 4) {
                    plazos.add(PlazoRecord(
                        categoria     = partes.getOrNull(0)?.trim() ?: "",
                        descripcion   = partes.getOrNull(1)?.trim() ?: "",
                        valor         = partes.getOrNull(2)?.trim() ?: "",
                        tipoComputo   = partes.getOrNull(3)?.trim() ?: "",
                        articulo      = partes.getOrNull(4)?.trim() ?: "",
                        observaciones = partes.getOrNull(5)?.trim() ?: ""
                    ))
                }
            }
        } catch (e: Exception) {
            println("Error cargando plazos: ${e.message}")
        }
        
        cachedPlazos = plazos
        return plazos
    }

    suspend fun buscarPlazos(query: String): List<PlazoRecord> {
        val todos = getPlazos()
        if (query.isBlank()) return todos
        
        val normalizedQuery = query.lowercase() // Simplificado si no tengo acceso fácil a normalized() aquí sin importar
        
        return todos.filter { record ->
            record.categoria.contains(query, ignoreCase = true) ||
            record.descripcion.contains(query, ignoreCase = true) ||
            record.articulo.contains(query, ignoreCase = true) ||
            record.observaciones.contains(query, ignoreCase = true)
        }
    }
}
